<template>
  <div class="tf card-filters mb-3">
    <div class="card-body">
      <div class="tf-head d-flex align-items-center gap-2">
        <h4 class="h6 m-0 d-inline-flex align-items-center">
          Filtrai
          <span
            v-if="appliedCount > 0"
            class="tf-count-badge ms-2"
            aria-live="polite"
          >
            {{ appliedCount }}
          </span>
        </h4>

        <button
          class="btn btn-sm btn-link text-decoration-none ms-auto d-inline-flex align-items-center gap-1"
          :aria-expanded="open.toString()"
          aria-controls="tf-body"
          @click="open = !open"
        >
          <span>{{ open ? 'Slėpti' : 'Rodyti' }}</span>
          <span class="tf-chevron" :class="{ 'is-open': open }">
            <i class="fa-solid fa-chevron-down"></i>
          </span>
        </button>
      </div>

      <transition name="tf-fade">
        <div v-show="open" id="tf-body">
          <div class="row g-4">
            <!-- Assortments -->
            <div class="col-md-6">
              <label class="form-label fw-bold d-block mb-2"
                >Asortimentas</label
              >

              <!-- external chips -->
              <!--              <div v-if="local.assortments.length" class="tf-chips mb-2">
                <span
                  v-for="id in local.assortments"
                  :key="`a-${id}`"
                  class="tf-chip"
                >
                  {{ nameById(assortments, id) }}
                  <button
                    class="tf-chip-x"
                    @click="unselect('assortments', id)"
                  >
                    ×
                  </button>
                </span>
              </div>-->

              <TenderMultiSelect
                v-model="local.assortments"
                :options="assortments"
                placeholder="Paieška…"
                @change="emitChange"
              />
            </div>

            <!-- Service types -->
            <div class="col-md-6">
              <label class="form-label fw-bold d-block mb-2"
                >Paslaugų rūšys</label
              >

              <!--              <div v-if="local.serviceTypes.length" class="tf-chips mb-2">
                <span
                  v-for="id in local.serviceTypes"
                  :key="`s-${id}`"
                  class="tf-chip"
                >
                  {{ nameById(serviceTypes, id) }}
                  <button
                    class="tf-chip-x"
                    @click="unselect('serviceTypes', id)"
                  >
                    ×
                  </button>
                </span>
              </div>-->

              <TenderMultiSelect
                v-model="local.serviceTypes"
                :options="serviceTypes"
                placeholder="Paieška…"
                @change="emitChange"
              />
            </div>
          </div>

          <div class="tf-actions d-flex gap-2 mt-3 w-100">
            <button
              class="btn btn-primary btn-sm ms-auto ml-auto btn-apply-filters"
              @click="apply"
            >
              Taikyti
            </button>
            <button
              class="btn btn-outline-secondary btn-sm btn-clear-filters"
              @click="clear"
            >
              Išvalyti
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import TenderMultiSelect from './TenderMultiSelect.vue'

export default {
  name: 'TenderFilters',
  components: { TenderMultiSelect },
  props: {
    assortments: { type: Array, default: () => [] }, // [{ id, name }]
    serviceTypes: { type: Array, default: () => [] }, // [{ id, name }]
    value: {
      type: Object,
      default: () => ({ assortments: [], serviceTypes: [] }),
    },
    defaultOpen: { type: Boolean, default: false },
  },
  data() {
    return {
      local: {
        assortments: [...(this.value.assortments || [])],
        serviceTypes: [...(this.value.serviceTypes || [])],
      },
    }
  },
  computed: {
    // eslint-disable-next-line vue/no-dupe-keys
    open: {
      get() {
        return this.$store.getters['tenders/getShowFilters']
      },
      set(v) {
        this.$store.dispatch('tenders/toggleShowFilters', v)
      },
    },
    appliedCount() {
      const v = this.value || {}
      const a = Array.isArray(v.assortments) ? v.assortments.length : 0
      const s = Array.isArray(v.serviceTypes) ? v.serviceTypes.length : 0
      return a + s
    },
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        this.local.assortments = [...(v.assortments || [])]
        this.local.serviceTypes = [...(v.serviceTypes || [])]
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('input', { ...this.local })
    },
    apply() {
      this.$emit('apply', { ...this.local })
    },
    clear() {
      this.local = { assortments: [], serviceTypes: [] }
      this.$emit('input', { ...this.local })
      this.$emit('apply', { ...this.local })
    },
    nameById(list, id) {
      const it = list.find((i) => String(i.id) === String(id))
      return it ? it.name : id
    },
    unselect(key, id) {
      this.local[key] = this.local[key].filter((v) => String(v) !== String(id))
      this.emitChange()
    },
  },
}
</script>

<style scoped></style>
